import React from "react";
import FaqComponent from "../../../components/faqComponent/FaqComponent";

const FAQ = () => {
  return <FaqComponent />;
};

export default FAQ;
